/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Create, Edit, SimpleForm, useTranslate } from 'react-admin';
import ScormForm from './ScormForm';
import statusEnum from '../../enums/status.enum';

const ScormDetail = (props) => {
  const { actionType } = props;
  const translate = useTranslate();
  const statusLabel = translate('custom.general.status');
  const nameLabel = translate('custom.general.name');
  const fileName = translate('custom.scorms.fichero');
  return (
    <>
      {actionType === 'edit' ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Edit {...props}>
          <SimpleForm>
            <ScormForm
              status={statusEnum}
              statusLabel={statusLabel}
              nameLabel={nameLabel}
              fileName={fileName}
            />
          </SimpleForm>
        </Edit>
      ) : (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Create {...props}>
          <SimpleForm>
            <ScormForm
              status={statusEnum}
              statusLabel={statusLabel}
              nameLabel={nameLabel}
              fileName={fileName}
            />
          </SimpleForm>
        </Create>
      )}
    </>
  );
};

ScormDetail.propTypes = {
  actionType: PropTypes.string,
};

ScormDetail.defaultProps = {
  actionType: 'create',
};

export default ScormDetail;
